import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StudentsUIHelpers";

const StudentsUIContext = createContext();

export function useStudentsUIContext() {
  return useContext(StudentsUIContext);
}

export const StudentsUIConsumer = StudentsUIContext.Consumer;

export function StudentsUIProvider({ studentsUIParameters, children }) {
  const [absenteeismValues, setAbsenteeismValues] = useState();
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    absenteeismValues,
    setAbsenteeismValues,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    date: studentsUIParameters.date,
    sectionId: studentsUIParameters.sectionId,
    absenteeismStatus: studentsUIParameters.absenteeismStatus,
    isApplication: studentsUIParameters.isApplication,
    isMail: studentsUIParameters.isMail,
    isSms: studentsUIParameters.isSms
  };

  return (
    <StudentsUIContext.Provider value={value}>
      {children}
    </StudentsUIContext.Provider>
  );
}